import { of as observableOf } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AlertService } from '../alert/alert.service';
import { ProprieteService } from './propriete.service';

@Injectable()
export class AppPropertiesResolver {
	constructor(private alertService: AlertService, private proprieteService: ProprieteService) {
	}

	resolve() {
		return this.proprieteService.lister().pipe(
				catchError(error => {
					this.alertService.error(error.error);
					return observableOf(null);
				}));
	}
}
